// extracted by mini-css-extract-plugin
export var content = "styles-module--content--0ef2b";
export var title = "styles-module--title--85ee9";
export var wrapper = "styles-module--wrapper--3e5c9";